<div class="lesson-script">
  <div class="lesson-script__title">{{ 'app.components.courseCreator.publish.lessonsInformation.scriptTitle' | translate }}</div>
  @if (isLoading()) {
    <div class="lesson-script__content lesson-script__content--loading">Loading script...</div>
  } @else if (hasError()) {
    <div class="lesson-script__content lesson-script__content--error">Failed to load script</div>
  } @else if (script()) {
    <div class="lesson-script__content">{{ script() }}</div>
  } @else {
    <div class="lesson-script__content">No script available</div>
  }
</div>

